// extracted by mini-css-extract-plugin
export default {"modal":"SuccessModal_modal__5yP8l","wrapper":"SuccessModal_wrapper__SsdAH","title":"SuccessModal_title__A6NhX","text":"SuccessModal_text__u1gJp","icon":"SuccessModal_icon__3UaDB"};